// API Reference: https://www.wix.com/corvid/reference
// “Hello, World!” Example: https://www.wix.com/corvid/hello-world

$w.onReady(function () {
	// Write your JavaScript here
	//$w("#lightbox1").

	// To select an element by ID use: $w("#elementID")

	// Click "Preview" to run your code
});